import React from 'react';
import { Box, Popover, PopoverOrigin } from '@mui/material';
import { anchorRef, bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';

import { FilterButton } from './filter-button.component';

import { Typography } from '../../data-display/typography/typography.component';
import { ArrowDropDownIcon } from '../../../icons/importedIcons';

const DEFAULT_WIDTH = 430;
const DEFAULT_ANCHOR_ORIGIN: PopoverOrigin = { horizontal: 'left', vertical: 'bottom' };

export type FilterWithPopoverProps = {
  renderFilterForm: (props: { onFilterClose: () => void }) => React.ReactNode;
  filterButtonLabel: string;

  disabled?: boolean;
  popoverProps?: {
    width?: number;
    anchorOrigin?: PopoverOrigin;
  };
};

export const FilterWithPopover = ({
  renderFilterForm,
  filterButtonLabel,
  popoverProps,
  disabled,
}: FilterWithPopoverProps) => {
  const filterPopupState = usePopupState({ variant: 'popover' });
  const filterPopoverProps = React.useMemo(() => {
    return {
      ...bindPopover({
        ...filterPopupState,
      }),
    };
  }, [filterPopupState]);

  const filterFormProps = React.useMemo(() => {
    return {
      onFilterClose: filterPopoverProps.onClose,
    };
  }, [filterPopoverProps.onClose]);

  return (
    <Box>
      <FilterButton
        variant='outlined'
        {...bindTrigger(filterPopupState)}
        ref={anchorRef(filterPopupState)}
        endIcon={
          <ArrowDropDownIcon sx={{ color: disabled ? 'action.disabled' : 'action.active' }} />
        }
        disabled={disabled}
      >
        <Typography variant='body1'>{filterButtonLabel}</Typography>
      </FilterButton>

      <Popover
        {...filterPopoverProps}
        anchorOrigin={popoverProps?.anchorOrigin ?? DEFAULT_ANCHOR_ORIGIN}
        slotProps={{ paper: { sx: { width: popoverProps?.width ?? DEFAULT_WIDTH } } }}
        keepMounted
      >
        {renderFilterForm(filterFormProps)}
      </Popover>
    </Box>
  );
};
